import api from './api';

export const riskExposureService = {
  getRisks: async (params = {}) => {
    try {
      const response = await api.get('/finance/risk/risks', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getRisk: async (riskId) => {
    try {
      const response = await api.get(`/finance/risk/risks/${riskId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  createRisk: async (data) => {
    try {
      const response = await api.post('/finance/risk/risks', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  updateRisk: async (riskId, data) => {
    try {
      const response = await api.put(`/finance/risk/risks/${riskId}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  deleteRisk: async (riskId) => {
    try {
      const response = await api.delete(`/finance/risk/risks/${riskId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  createMitigationPlan: async (data) => {
    try {
      const response = await api.post('/finance/risk/mitigation-plans', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getRiskReports: async (params = {}) => {
    try {
      const response = await api.get('/finance/risk/reports', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  generateInsights: async (data) => {
    try {
      const response = await api.post('/finance/risk/ai-insights', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};
